import { z } from 'zod/v4'
import { create } from 'zustand'
import { UnifiedDeepLinkData } from 'react-native-appsflyer'
const ReferralCode = z.string({ message: 'Referral code is not a string' })

export const useCardApplicationReferralCodeStore = create<{
  referralCode: string | undefined
  setReferralCode: (referralCode: string | undefined) => void
  setReferralCodeFromDeepLink: (deepLinkData: UnifiedDeepLinkData['data']) => void
  clearReferralCode: () => void
}>((set) => ({
  referralCode: undefined,
  setReferralCode: (referralCode: string | undefined) => set({ referralCode }),
  setReferralCodeFromDeepLink: (deepLinkData: UnifiedDeepLinkData['data']) => {
    const { data: referralCode } = ReferralCode.safeParse(deepLinkData.referral_code)
    if (referralCode) {
      set({ referralCode })
    }
  },
  clearReferralCode: () => set({ referralCode: undefined }),
}))
